import { createStyles, rem } from '@mantine/core'

export default createStyles(() => {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: rem(12),
    },
    timeBar: {
      textAlign: 'center',
    },
    highlightMessage: {
      cursor: 'pointer',
    },
    errorTxt: {},
    indicator: {},
    action: {},
    scrollBody: {},
  }
})
